<template>
    <div class="tracking-graph-wrapper">
        <div class="tracking-graph">
            <div class="main-info">
                <div class="main-info--name">{{ name }}</div>
                <div class="main-info--schedule">Programada hasta: {{ scheduledDate }}</div>
                <div class="main-info--oee">{{ oee }}%</div>
                <div class="main-info--shift-delay">
                    <div class="title">RETRASO EN EL TURNO</div>
                    <div class="delay">{{ shiftDelay }}</div>
                </div>
                <div class="main-info--actual-quantity">
                    <div class="title">TABLEROS GASTADOS</div>
                    <div class="delay">{{ rawQuantity }}/{{ totalRawQuantity }}</div>
                </div>
            </div>

            <div class="secondary-info">
                <div class="order">
                    <div class="order-info">
                        <div class="order-info--name">
                            <div class="title">PEDIDO:</div>
                            <div class="value">{{ order }}</div>
                        </div>
                        <div class="order-info--program">
                            <div class="title">PROGRAMA:</div>
                            <div class="value">{{ program }}</div>
                        </div>
                        <div class="order-info--schema">
                            <div class="title">ESQUEMA:</div>
                            <div class="value">{{ schema }}</div>
                        </div>
                    </div>
                    <div class="order-delay">
                        <div class="order-delay--title">Retraso Acumulado Pedido</div>
                        <div class="order-delay--delay">{{ orderDelay }}</div>
                    </div>
                </div>
                <div class="actual-info">
                    <div class="progress-bar-wrapper">
                        <div class="completed-percentage">{{ completedPercentage }}% Completado</div>
                        <div class="theoretical-end">
                            <span>Finalizacion Prevista:</span>
                            <span>{{ theoreticalEndDate }}</span>
                        </div>
                        <div class="progress-bar"></div>
                        <div class="remaining-quantities">
                            <div class="remaining-quantity">
                                <div class="remaining-quantity--title">Nº Piezas Ptes.:</div>
                                <div class="remaining-quantity--value">{{ remainingQuantity }}</div>
                            </div>
                            <div class="remaining-schemas">
                                <div class="remaining-schemas--title">Nº Esquemas Ptes.:</div>
                                <div class="remaining-schemas--value">{{ remainingSchemas }}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="tracking">
<!--                    Automatico-->
                    <table class="table">
                        <tr>
                            <th>Id Pieza</th>
                            <th>Carro</th>
                            <th>Id Pieza</th>
                            <th>Codigo Barras</th>
                        </tr>
                    </table>
<!--                    Automatico-->
                </div>
            </div>
        </div>
        <div class="logos"></div>
    </div>
</template>

<script>
export default {
    name: "TrackingGraph",
    props:{},
    data(){
        return {
            name: 'COR-01',
            scheduledDate: new Date().toLocaleString(),
            oee: 82,
            shiftDelay: 1547,
            rawQuantity: 5,   //CANTIDAD DE TABLEROS GASTADOS DEL TOTAL, NO CANTIDAD DE TABLAS HECHAS
            totalRawQuantity: 14,  //CANTIDAD DE TABLEROS GASTADOS DEL TOTAL, NO CANTIDAD DE TABLAS HECHAS

            order: 'PT-22 5621',
            program: '0594JANGELLEVANTEH13345T910',
            schema: '014',
            orderDelay: 4041,

            completedPercentage: 53,
            theoreticalEndDate: new Date().toLocaleString(),
            remainingQuantity: 54,
            remainingSchemas: 4,

            barcodes:[
                {
                    id: 1,
                    position: 'Canteadora',
                    destiny: 'CANT01',
                    barcode: '2934572039845'
                },
                {
                    id: 1,
                    position: 'Canteadora',
                    destiny: 'CANT01',
                    barcode: '2934572039845'
                },
                {
                    id: 1,
                    position: 'Expediciones',
                    destiny: 'EXPED01',
                    barcode: '2934572039845'
                },
                {
                    id: 1,
                    position: 'Canteadora',
                    destiny: 'CANT01',
                    barcode: '2934572039845'
                },

            ]

        }
    },
    methods:{},
    computed:{}
}
</script>

<style lang="scss" scoped>
.tracking-graph-wrapper {
    padding: 0 1rem;
    .tracking-graph {
        display: flex;
        gap: 4rem;
        .main-info {
            display: flex;
            flex-direction: column;
            &--name {
                font-size: 5rem;
                font-weight: 700;
            }
            &--schedule {
                font-size: 1.7rem;
                white-space: nowrap;
                margin-left: 0.25rem;
                color: #2363AB;
                font-weight: 600;
            }
            &--oee {
                font-size: 11rem;
                color: #6A6A6A;
                font-weight: 700;
                text-align: center;
            }
            &--shift-delay {
                background: #B8361E;
                color: white;
                text-align: center;
                font-size: 2rem;
                padding: 1.25rem 5rem;
                margin: 1rem 0;
                border-radius: 5px;
                .title {
                    font-weight: 300;
                }
                .delay {
                    font-weight: 600;
                    font-size: 2.3rem;
                }
            }
            &--actual-quantity {
                background: #318C46;
                color: white;
                text-align: center;
                font-size: 2rem;
                margin: 1rem 0;
                padding: 1.25rem 5rem;
                border-radius: 5px;
                .title {
                    font-weight: 300;
                }
                .delay {
                    font-weight: 600;
                    font-size: 3.5rem;
                }
            }
        }

        .secondary-info {
            padding-top: 1rem;
            .order {
                margin-bottom: 6rem;
                display: flex;
                gap: 4rem;
                &-info {
                    display: flex;
                    flex-direction: column;
                    & > div {
                        display: inline-flex;
                        gap: 1rem;

                        & .title {
                            color: dimgray;
                            font-weight: 700;
                            font-size: 1.3rem;
                        }
                        & .value {
                            color: gray;
                            font-size: 1.3rem;
                        }

                    }
                }
                &-delay {
                    color: darkred;
                    text-align: center;
                    &--title {
                        font-size: 1.5rem;
                    }
                    &--delay {
                        font-size: 1.9rem;
                        font-weight: 500;
                    }
                }
            }

            .actual-info {
                .progress-bar-wrapper {
                    position: relative;
                    .completed-percentage {
                        color: darkslategray;
                        font-size: 1.5rem;
                        font-weight: 600;
                    }
                    .theoretical-end {
                        color: darkred;
                        font-size: 1.2rem;
                        display: flex;
                        flex-direction: column;
                        font-weight: 500;
                        position: absolute;
                        top: 0;
                        transform: translate(0, -81%);
                        left: 60%;

                        &:before {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            width: 5px;
                            height: 5px;
                            background: darkred;
                        }
                    }
                    .progress-bar {
                        height: 2.75rem;
                        width: 100%;
                        border-radius: 5px;
                        background: linear-gradient(90deg, #F9B401 40%, transparent 40%);
                        border: 1px solid lightgray;
                        margin-bottom: 1.5rem;
                    }
                    .remaining-quantities {
                        display: flex;
                        flex-direction: column;
                        margin: 0 0 2rem 0;

                        .remaining-quantity {
                            font-size: 1.05rem;
                            display: inline-flex;
                            gap: 2rem;
                            align-items: center;
                            &--title {
                                color: dimgray;
                                font-size: 1.3rem;
                                height: max-content;
                            }
                            &--value {
                                color: dimgray;
                                font-size: 2rem;
                                font-weight: 700;
                            }
                        }
                        .remaining-schemas {
                            font-size: 1.05rem;
                            display: inline-flex;
                            gap: 2rem;
                            align-items: center;
                            &--title {
                                color: dimgray;
                                font-size: 1.3rem;
                                height: max-content;
                            }
                            &--value {
                                color: dimgray;
                                font-size: 2rem;
                                font-weight: 700;
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>